module.exports = __webpack_public_path__ + "media/images/sales/early/text-mv-copy-1-fccfdc87bbc9679636b1e320c22beae9.svg";